/* v77c (2026-05-08): Move OPIS description below image gallery on desktop.
   Caroline + Pat 2026-05-08: the empty white space below the image gallery
   on tall right-column products (especially monoporcje + coffee) was unsightly.
   Description naturally fits there. On mobile we keep single-column flow with
   description at the bottom (standard mobile UX).

   Originally implemented as v77 IIFE inside custom.js, but Shopify's minifier
   joined it with prior IIFEs via comma operator, so a v58 exception thrown on
   single-variant products aborted v77 before it could run. Extracted to a
   dedicated module loaded via snippets/zip-cookies.liquid for IIFE isolation.

   Affects every product template — the .product__block__description element
   renders in all of them. */

(function () {
  if (window.__batidaDescLayoutLoaded) return;
  window.__batidaDescLayoutLoaded = true;

  var DESKTOP_BREAKPOINT = 1024;

  function relocate() {
    try {
      var desc = document.querySelector('.product__block__description');
      var media = document.querySelector('.grid__item.product__media__wrapper');
      if (!desc || !media) return;

      var isDesktop = window.innerWidth >= DESKTOP_BREAKPOINT;
      var isRelocated = desc.parentElement === media;

      if (isDesktop && !isRelocated) {
        media.appendChild(desc);
        desc.classList.add('batida-desc-relocated');
        window.__batidaDescLayoutRelocatedAt = Date.now();
      } else if (!isDesktop && isRelocated) {
        var details = document.querySelector('.product__inner.is-sticky');
        if (details) {
          details.appendChild(desc);
          desc.classList.remove('batida-desc-relocated');
        }
      }
    } catch (e) {
      try { console.warn('batida desc-layout relocate error:', e); } catch (_) {}
    }
  }

  function init() {
    if (window.__batidaDescLayoutInit) return;
    window.__batidaDescLayoutInit = true;
    relocate();
    setTimeout(relocate, 200);
    setTimeout(relocate, 800);
    setTimeout(relocate, 2000);
    setTimeout(relocate, 5000);

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(relocate, 150);
    });

    try {
      var __mo = null, __idle = null;
      var __stop = function () { if (__mo) { try { __mo.disconnect(); } catch (e) {} __mo = null; } };
      var __bump = function () { clearTimeout(__idle); __idle = setTimeout(__stop, 4000); };
      var __arm = function () { if (__mo) return; try { __mo = new MutationObserver(function () { relocate(); __bump(); }); __mo.observe(document.body, { childList: true, subtree: true }); __bump(); } catch (e) {} };
      __arm();
      ['click', 'change'].forEach(function (ev) { document.addEventListener(ev, function () { relocate(); __arm(); }, true); });
    } catch (e) {}
  }

  try { relocate(); } catch (_) {}
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else if (document.readyState !== 'complete') {
    window.addEventListener('load', init);
    init();
  } else {
    init();
  }
})();
